module.exports = __webpack_public_path__ + "static/sour-cream-onion-lg-f4e0bf543fb56ed268038ded9a6e56ac.jpg";